import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import download from "../../asset/images/partner-download.svg";
import { toast } from "react-toastify";
import { Frenchisee } from "../../Configuration/Frenchisee_URL";
import { decryptData, encryptData, handleDownloadDocument } from "../../CommonMethhods/CommonMethods";
import DocumentUploader from "./DocumentUploader";
import PreviewModal from "./PreviewModal";
import { DOCUMENT_TYPE_MAP } from "../../CommonMethhods/Constants";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function ComplianceDetailsPreview(props) {
  const storeToken = localStorage.getItem("ssoToken");
  let FrenchiseeId = localStorage.getItem("complianceId");
  let navigate = useNavigate();
  let frenchiseeDatails = props.frenchiseeDatails;
  const [rejectionData, setRejectionData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState();
  const [uploadModalShow, setUploadModalShow] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewFileName, setPreviewFileName] = useState("");
  const [showModalRej, setShowModalRej] = useState(false);
  const [nameVal, setNameVal] = useState("");
  const fileInputRefs = useRef({});
  const documentConfig = [
    { label: "BFSL Sign Board", docKey: "38", isDefault: true },
    { label: "NSE Registration Certificate", docKey: "35", isDefault: true },
    { label: "BSE Registration Certificate", docKey: "36", isDefault: true },
    { label: "Client Visitor Register", docKey: "39", isDefault: true },
    { label: "Client Complaint Register", docKey: "40", isDefault: true },
    { label: "Do's and Dont's Certificate", docKey: "37", isDefault: true, optional: true },
    { label: "SEBI Certificate", docKey: "41", isDefault: true, optional: true },
    { label: "Investor Charter for Depository Participants NSDL", docKey: "42", isDefault: true },
    { label: "Investor Charter for Depository Participants CDSL", docKey: "43", isDefault: true },
    { label: "Investor Charter Stockbroker", docKey: "44", isDefault: true },
    { label: "Investor Grievance escalation matrix", docKey: "45", isDefault: true },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const buildInitialState = (defaultValue) => {
    return documentConfig.reduce((acc, { docKey }) => {
      acc[docKey] = defaultValue;
      return acc;
    }, {});
  };

  const [fileTypes, setFileTypes] = useState(buildInitialState(""));
  const [fileTypeErrors, setFileTypeErrors] = useState(buildInitialState(""));
  const [fileData, setFileData] = useState(buildInitialState(null));


  const initializeDocumentData = () => {
    const initialState = {};
    documentConfig.forEach(({ docKey }) => {
      initialState[docKey] = { name: "", isAvailable: false, url: "", type: "" };
    });
    return initialState;
  };

  const [documentData, setDocumentData] = useState(initializeDocumentData);

  useEffect(() => {
    getUploadedDocsList()
  }, [])

  const getUploadedDocsList = async () => {

    try {
      const getValueList = await axiosInstance.get(
        `${Frenchisee.GetDocumentsList_Url}?fid=${FrenchiseeId}&fileType=0`,
      );
      const getDocListRes = decryptData(getValueList?.data);
      let getResp = JSON.parse(getDocListRes);
      if (getResp?.status === 0) {
        // setDocList(getResp?.data?.info)
        let docValue = getResp?.data?.info;
        console.log(docValue, "docValue99865789");
        const sampleData = {};
        const uploadedDocKeys = [];

        docValue.forEach((doc) => {
          const key = String(doc?.type);
          if (!key) return;

          sampleData[key] = {
            name: doc?.dfname || "",
            isAvailable: true,
            url: doc?.url || "",
            type: doc?.type || "",
          };
          uploadedDocKeys.push(key);
        });

        setDocumentData(sampleData)
      } else {
        toast.error(getResp?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onHide = () => {
    setShowModalRej(false);
  };

  useEffect(() => {
    // getRejectionReason();
    setSelectedFiles([]);
  }, []);

  function handleDocumentUpload(e, type) {
    if (e?.target?.files?.length > 0) {
      const file = e.target.files[0];
      const sizeKB = Math.round(file.size / 1024);
      const fileExtension = file.name.split(".").pop().toLowerCase();

      setFileTypes((prev) => ({ ...prev, [type]: fileExtension }));

      if (sizeKB > 2048) {
        setFileTypeErrors((prev) => ({ ...prev, [type]: "File size should be 2MB or less." }));
        return;
      }

      if (!["png", "jpeg", "jpg", "pdf"].includes(fileExtension)) {
        setFileTypeErrors((prev) => ({ ...prev, [type]: "This file format is not supported." }));
        return;
      }

      const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;
      if (specialCharRegex.test(file.name)) {
        setFileTypeErrors((prev) => ({ ...prev, [type]: "Invalid file name." }));
        return;
      }

      setFileTypeErrors((prev) => ({ ...prev, [type]: "" }));
      setFileData((prev) => ({ ...prev, [type]: file }));
      uploadeDocuments(e, type);
    }
  }

  const getRejectionReason = async () => {
    try {
      const getRejection = await axiosInstance.get(
        Frenchisee.REJECT_REASONS,
      );
      const data = getRejection.data;
      // let dataResp = JSON.parse(data)
      setRejectionData(data.data.rejectReasons);
    } catch (error) {
      console.log(error);
    }
  };

  const rejectedUpdated = async () => {
    let rejPayload = {
      id: parseInt(FrenchiseeId),
      status: -4,
      reason: selectedFiles,
    }
    let encyData = encryptData(JSON.stringify(rejPayload))
    try {
      const getStatus = await axiosInstance.put(
        Frenchisee.REJECTION_UPDATED,
        `${encyData}`,
        //   {
        //     id: parseInt(FrenchiseeId),
        // status: -2,
        // reason: selectedFiles,
        //   },
      );
      const dataVal = decryptData(getStatus.data);
      let dataResp = JSON.parse(dataVal);
      if (dataResp?.data) {
        toast.success(dataResp?.data?.message);
        setShowModalRej(false);
        navigate("/compliance-dashboard");
      } else {
        setShowModalRej(true);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
    }
  };

 const approvedStatus = async () => {
    let approvePayload = {
      id: parseInt(FrenchiseeId),
      status: 4,
    }
    console.log(approvePayload, "approvePayload");

    let payload = encryptData(JSON.stringify(approvePayload))

    try {
      const getValue = await axiosInstance.put(
        Frenchisee.REJECTION_UPDATED,
        `${payload}`,
      );
      const data = decryptData(getValue?.data);
      let approveRes = JSON.parse(data);
      console.log(approveRes?.data, "approveRes");

      if (approveRes?.status === 0) {
        toast.success(approveRes?.data?.message);
        setUploadModalShow(false);

        navigate("/compliance-dashboard");
      }
      else {
        toast.error(approveRes?.message)
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
    }
  };

  const downloadMultiple = (checked = true) => {
    const selectDownload = document.querySelectorAll(".downloadSelect");
    let selectArray = [];
    for (let item of selectDownload) {
      if (checked) {
        if (item.checked === true) {
          selectArray.push(parseInt(item.value));
        }
      } else {
        selectArray.push(item.value);
      }
    }
    setSelectedFiles(selectArray);
  };
  const getReason = () => {
    downloadMultiple();
  };

  const uploadeDocuments = async (e, type) => {
    try {
      const formData = new FormData();
      formData.append("file", e?.target?.files[0]);
      formData.append("type", type);
      formData.append("fid", FrenchiseeId)

      const getValue = await axiosInstance.post(
        `${Frenchisee.GetDocumentsList_Url}`,
        formData,
      );
      const response = decryptData(getValue?.data);
      let decResponse = JSON.parse(response)
      if (decResponse?.status === 0) {
        let object = { isAvailable: true, type: type, urlVal: decResponse?.data?.info?.url };
        setDocumentData({ ...documentData, [type]: object })
        getUploadedDocsList();
      }
      else if (response?.status === 1) {
        toast.error(response?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message)
    }
  };

  const deleteDocuments = async (type) => {
    try {
      const getDeleteData = await axiosInstance.delete(
        `${Frenchisee.GetDocumentsList_Url}?fid=${FrenchiseeId}&fileType=${type}`,
      );
      const deletedResp = decryptData(getDeleteData?.data);
      let delRep = JSON.parse(deletedResp)
      if (delRep?.status === 0) {
        toast.success(delRep?.data?.message)
        // getApiData();
        setDocumentData((prev) => {
          const newData = { ...prev };
          delete newData[type];
          return newData;
        });
        setFileData((prev) => ({ ...prev, [type]: null }));

        if (fileInputRefs.current[type]) {
          fileInputRefs.current[type].value = "";
        }
        getUploadedDocsList()
      }
      else {
        toast.error(delRep?.message);
        setDocumentData([])

      }
    } catch (error) {
      console.log(error);
    }
  };

  const showResponseApprove = () => {
    approvedStatus();
  };

  const handlePreview = (nameExt, url, name) => {
    setNameVal(nameExt)
    // if (!url) return;
    setPreviewUrl(url);
    setPreviewFileName(name);
    setShowModal(true);
  };

  const isApproveDisabled = () => {
    const requiredDocs = documentConfig
      .filter(({ docKey, optional }) => docKey !== "35" && docKey !== "36" && !optional);

    // Check all other required docs
    const allRequiredUploaded = requiredDocs.every(({ docKey }) => documentData[docKey]?.isAvailable);

    // NSE or BSE condition
    const nseUploaded = documentData["35"]?.isAvailable;
    const bseUploaded = documentData["36"]?.isAvailable;
    const hasNseOrBse = nseUploaded || bseUploaded;

    return !(allRequiredUploaded && hasNseOrBse);
  };

  const downloadAllDoc = async (data) => {

        try {
            const getAllData = await axiosInstance.get(
                `${Frenchisee.Download_AllDoc}?fid=${FrenchiseeId}`,
            );

            const getData = decryptData(getAllData?.data);
            let response = JSON.parse(getData)
            if (response?.status === 0) {
                let files = response?.data;
                window.open(files, "_self", "noopener,noreferrer");
            }
            else {
                toast?.error(response?.message)
            }

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const handleDownloadBtn = () => {
        downloadAllDoc();
    };


  return (
    <>
      <div className="card-box">
        <div className="card-title">
          <h2 className="">Document</h2>
           <span className="download-btn-franch" onClick={() => handleDownloadBtn()}>
              <img src={download} alt="" className="download-img partner-down" />
              Download All
          </span>
        </div>

        <div className="">
          <div className="">
            <div className="row imgWrapper">
              {frenchiseeDatails &&
                frenchiseeDatails?.file?.map((item) => {
                  return (
                    <>
                      <div key={item?.id} className='col-md-6 bottom-25'>
                        <p className='pdf-label'>
                          {DOCUMENT_TYPE_MAP[item?.type]}</p>
                        <div className='document-wrapper'>

                          {item?.fname?.split(".")[1] === 'pdf' ? (
                            < iframe src={item?.url}
                              className="document-pdf partner-down" />
                          )
                            :
                            (
                              <img src={item?.url} className='document-img'
                                alt='document-img' />
                            )
                          }
                          <img src={download} alt="" className="download-img partner-down"
                            onClick={() => {
                              handleDownloadDocument(item?.url)
                            }} />
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        </div>
        {frenchiseeDatails?.statusId === 3 ? (
          <div className="partner-btn">
            <div>
              <button
                className="upload-btn"
                type="submit"
                onClick={() => setUploadModalShow(true)}
              >
                UPLOAD
              </button>
            </div>
            <div>
              <button
                className="rej-btn"
                type="submit"
                onClick={() => setShowModalRej(true)}
              >
                REJECT
              </button>
            </div>
            <div>
              <button
                className="back-btn"
                type="submit"
                onClick={() => {
                  navigate("/compliance-dashboard");
                }}
              >
                BACK
              </button>
            </div>
          </div>
        ) : (
          <div>
            <button
              className="back-btn"
              type="submit"
              onClick={() => {
                navigate("/compliance-dashboard");
              }}
            >
              Back
            </button>
          </div>
        )}
      </div>
      <Modal
        show={showModalRej}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model partner-modal-rejection"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">Rejection Selection</h2>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="reject-modal">
            <h3 className="rejection-modal">Your application has been rejected.</h3>

            <ul className="partner-ul">
              {rejectionData &&
                rejectionData?.map((item) => {
                  return (
                    <>
                      <li>
                        <input
                          type="checkbox"
                          id="resons"
                          value={item.id}
                          className="downloadSelect"
                          onClick={() => getReason()}
                        />
                        <label>{item.reason}</label>
                      </li>
                    </>
                  );
                })}
            </ul>
            <button
              type="submit"
              className="rej-btn reject-comp"
              onClick={() => rejectedUpdated()}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
      
      <Modal
        show={uploadModalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model partner-modal-upload"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <form autoComplete="off">
            <div className="body-wrapper">
              <h4 className="text-heading">Upload Document</h4>
              <span className="icon-close" onClick={() => setUploadModalShow(false)}></span>
            </div>
            <ul className="upload-certificate">
              {
                ((frenchiseeDatails?.nseFnO === true || frenchiseeDatails?.nseCapMarket === true) &&
                  (frenchiseeDatails?.bseFnO === false && frenchiseeDatails?.bseCapMarket === false)) ?
                  documentConfig.filter(({ docKey }) => docKey !== "36")
                    .map((doc) => (
                      <DocumentUploader
                        key={doc.docKey}
                        label={doc.label}
                        docKey={doc.docKey}
                        documentData={documentData}
                        fileData={fileData[doc.docKey]}
                        fileType={fileTypes[doc.docKey]}
                        fileTypeErr={fileTypeErrors[doc.docKey]}
                        onChange={(e) => handleDocumentUpload(e, doc.docKey)}
                        onDelete={() => deleteDocuments(doc.docKey)}
                        onPreview={handlePreview}
                         fileInputRefs={fileInputRefs}
                      />
                    ))
                  :
                  ((frenchiseeDatails?.bseFnO === true || frenchiseeDatails?.bseCapMarket === true) &&
                    (frenchiseeDatails?.nseFnO === false && frenchiseeDatails?.nseCapMarket === false)) ?
                    documentConfig.filter(({ docKey }) => docKey !== "35")
                      .map((doc) => (
                        <DocumentUploader
                          key={doc.docKey}
                          label={doc.label}
                          docKey={doc.docKey}
                          documentData={documentData}
                          fileData={fileData[doc.docKey]}
                          fileType={fileTypes[doc.docKey]}
                          fileTypeErr={fileTypeErrors[doc.docKey]}
                          onChange={(e) => handleDocumentUpload(e, doc.docKey)}
                          onDelete={() => deleteDocuments(doc.docKey)}
                          onPreview={handlePreview}
                           fileInputRefs={fileInputRefs}
                        />
                      ))
                    :

                    ((frenchiseeDatails?.bseFnO === true || frenchiseeDatails?.bseCapMarket === true) &&
                      (frenchiseeDatails?.nseFnO === true || frenchiseeDatails?.nseCapMarket === true)) ?
                      documentConfig
                        .map((doc) => (
                          <DocumentUploader
                            key={doc.docKey}
                            label={doc.label}
                            docKey={doc.docKey}
                            documentData={documentData}
                            fileData={fileData[doc.docKey]}
                            fileType={fileTypes[doc.docKey]}
                            fileTypeErr={fileTypeErrors[doc.docKey]}
                            onChange={(e) => handleDocumentUpload(e, doc.docKey)}
                            onDelete={() => deleteDocuments(doc.docKey)}
                            onPreview={handlePreview}
                             fileInputRefs={fileInputRefs}
                          />
                        ))
                      : null
              }
            </ul>

            <div className="upload-modal-wrapper">
              <div>
                <button
                  className={`${isApproveDisabled() ? "disable-btn appro-btn" : "appro-btn"}`}
                  type="button"
                  onClick={() => showResponseApprove()}
                  disabled={isApproveDisabled()}
                >
                  APPROVE
                </button>
              </div>
              <div>
                <button
                  className="back-btn"
                  type="button"
                  onClick={() => setUploadModalShow(false)}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal >

      <PreviewModal
        show={showModal}
        onHide={() => setShowModal(false)}
        fileUrl={previewUrl}
        fileName={previewFileName}
        nameExtension={nameVal}
      />
    </>
  );
}

export default ComplianceDetailsPreview;
